export const JourneyTypes = {
    APP_REQUEST: 'App Request',
    QUOTE_REQUEST: 'Quote Request',
    CONTACT_A_SPECIALIST: 'Contact a Specialist',
    POLICY_REVIEW: 'Policy Review',
    SECURIAN_E_APPLICATION: 'Securian E-Application'
}
